import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import {
  Table,
  TableBody,
  TableContainer,
  TableFooter,
  TableHead,
  TableProps
} from '../atom/Table'
import BaseColor from '../base/Color'

export type TableListProps = {
  head?: React.ReactNode
  body?: React.ReactNode
  footer?: React.ReactNode
  classContainer?: string
} & TableProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%'
    },
    container: {
      borderRadius: '8px 8px 0px 0px',
      height: '100%'
    },
    head: {
      background: BaseColor.primary[300],
      '& .MuiTableCell-root': {
        borderBottom: 'none'
      }
    }
  })
)

const TableList: React.FC<TableListProps> = (props) => {
  const classes = useStyles()
  const { head, body, footer, classContainer, ...rest } = props
  return (
    <TableContainer
      className={classContainer}
      classes={{ root: classes.container }}
    >
      <Table classes={{ root: classes.root }} {...rest}>
        {head && <TableHead classes={{ root: classes.head }}>{head}</TableHead>}
        {body && <TableBody>{body}</TableBody>}
        {footer && <TableFooter>{footer}</TableFooter>}
      </Table>
    </TableContainer>
  )
}

export default TableList
